import products from '../json/remotes.json'
import OrderApi from '../api/orderApi'
import router from '../../../mainRouter'

const appState = {
    products,
    cart: [],
    cartQuantity: 0,
    customer: null,
    previousOrders: [],
    maximumQuantityUserCanOrder: 3,
    isAuthenticated: false,
    lastName: '',
    accountNumber: ''
}

export default {
    namespaced: true,
    state: appState,
    actions: {
        async login ({ commit, dispatch, state }, payload) {
            try {
                dispatch('toggleLoading', { value: true }, { root: true })
                commit('setLoginData', { lastName: payload.lastName, accountNumber: payload.accountNumber })
                
                await OrderApi.verifyCaptcha({ token: payload.token })
                
                const authenticated = await OrderApi.auth({ lastName: state.lastName, accountNumber: state.accountNumber })
                
                commit('setCustomer', { customer: authenticated.data.customer })
                commit('setIsAuthenticated', { isAuthenticated: true })
          
                // check for previous orders
                await dispatch('fetchOrders')

                dispatch('toggleLoading', { value: false }, { root: true })
             
                if (state.previousOrders.length) {
                    router.push({ name: 'previous-orders' })
                } else {
                    router.push({ name: 'confirm-address' })
                }
               
            } catch (error) {
                dispatch('toggleLoading', { value: false }, { root: true })
                switch (error.response.status) {
                    case 401:
                        dispatch('togglePopup', {
                            type: 'COMMON/ERRORS/NOT_FOUND',
                        }, { root: true })
                        break;
                    case 403:
                        dispatch('togglePopup', {
                            type: 'COMMON/ERRORS/FORBIDDEN',
                        }, { root: true })
                        break;
                    case 500:
                        dispatch('togglePopup', {
                            type: 'COMMON/ERRORS/SERVER',
                        }, { root: true })
                        break;
                    default:
                        dispatch('togglePopup', {
                            type: 'COMMON/ERRORS/UNEXPECTED',
                        }, { root: true })
                        break;
                }
            }
        },
        async fetchOrders ({ commit, state, dispatch }) {
            const response = await OrderApi.retrieveOrders({ lastName: state.lastName, accountNumber: state.accountNumber })
            if (response.data) {
                commit('setMaximumQuantityUserCanOrder', { maximumQuantityUserCanOrder: response.data.maxAllowed })
                commit('setPreviousOrders', { previousOrders: response.data.searchResults })
            }

        },
        async destroyOrder ({ dispatch, state }, orderId) {
            const response = await OrderApi.delete(orderId, { lastName: state.lastName, accountNumber: state.accountNumber })
            if (response.status === 204) {
                await dispatch('fetchOrders')
            }

            if (!state.previousOrders.length) {
                router.push({ name: 'confirm-address' })
            }
        },
        async createOrder ({ commit, state, dispatch }, payload) {
            dispatch('toggleLoading', { value: true }, { root: true })
            commit('setEmailAddress', { emailAddress: payload.emailAddress })
            const response = await OrderApi.create({
                lastName: state.lastName,
                accountNumber: state.accountNumber,
                customer: state.customer,
                orderItems: state.cart
            })

            if (response.status === 201 || response.status === 204) {
                router.push({ name: 'confirmation' })
            }
            dispatch('toggleLoading', { value: false }, { root: true })
        },
        addProductToCart ({ commit, state }, product) {
            const limitQuantity = state.maximumQuantityUserCanOrder < 2 ? state.maximumQuantityUserCanOrder : 2

            if (state.cartQuantity === limitQuantity) {
                return
            } // stops the user from adding more products into the cart

            const cartItem = state.cart.find(item => item.contec_product_id === product.contec_id)

            // if cart item is empty push product to the cart
            if (cartItem === undefined) {
                commit('pushProductToCart', {
                    contec_product_id: product.contec_id,
                    quantity: 1
                })
                commit('increaseCartQuantity') // increase quantity count - limit is 2 per session
            } else {
                commit('incrementItemQuantity', cartItem)
                commit('increaseCartQuantity')
            }
        },
        subtractProductFromCart ({ commit, state }, product) {
            const cartItem = state.cart.find(item => item.contec_product_id === product.contec_id)
            if (cartItem === undefined || !cartItem.quantity) {
                return
            } // stop user here if no items in the cart
            commit('decreaseItemQuantity', cartItem)
            commit('decreaseCartQuantity')
        }
    },
    mutations: {
        setCustomer (state, payload) {
            state.customer = payload.customer
        },
        setIsAuthenticated (state, payload) {
            state.isAuthenticated = payload.isAuthenticated
        },
        setLoginData (state, payload) {
            state.lastName = payload.lastName
            state.accountNumber = payload.accountNumber
        },
        setEmailAddress (state, payload) {
            state.customer.emailAddress = payload.emailAddress
        },
        setPreviousOrders (state, payload) {
            state.previousOrders = payload.previousOrders
        },
        pushProductToCart (state, cartItem) {
            state.cart.push(cartItem)
        },
        // To revisit
        incrementItemQuantity (state, cartItem) {
            cartItem.quantity++
        },
        // To revisit
        decreaseItemQuantity (state, cartItem) {
            cartItem.quantity--
            // if cart item reaches 0 remove from cart
            if (!cartItem.quantity) {
                state.cart = state.cart.filter(x => x.contec_product_id !== cartItem.contec_product_id)
            }
        },
        increaseCartQuantity (state) {
            state.cartQuantity++
        },
        decreaseCartQuantity (state) {
            state.cartQuantity--
        },

        setMaximumQuantityUserCanOrder (state, payload) {
            state.maximumQuantityUserCanOrder = payload.maximumQuantityUserCanOrder
        },

    },
    getters: {
        allProducts: state => state.products,
        retrieveCartItems: state => state.cart,
        inCartTotal: state => id => state.cart.find(item => item.contec_product_id === id) ? state.cart.find(item => item.contec_product_id === id).quantity : 0,
        cartQuantity: state => state.cartQuantity,
        getCustomer: state => state.customer,
        getEmailAddress: state => state.customer.email,
        getSiteKey: state => state.reCaptchaSiteKey,
        getPreviousOrders: state => state.previousOrders,
        getMaximumQuantityUserCanOrder: state => state.maximumQuantityUserCanOrder,
        hasPermission (state) { return state.isAuthenticated }
    }
}
